<template>
  <div class="dropdown">
    <button
      class="btn btn-primary dropdown-toggle btn-sm d-inline-flex align-items-center"
      type="button"
      data-bs-toggle="dropdown"
      data-bs-auto-close="outside"
      aria-expanded="false"
    >
      <Icon icon="material-symbols:visibility-outline" class="me-2" />
      <span class="me-1">Columns </span>
    </button>
    <ul class="dropdown-menu z-3">
      <li>
        <button
          id="columnButtonShowAll"
          class="dropdown-item"
          type="button"
          @click="toggleAllColumns"
        >
          {{ allColumnsVisible ? 'Hide all columns' : 'Show all columns' }}
        </button>
      </li>
      <li><hr class="dropdown-divider" /></li>
      <div class="scrollable-menu custom-scrollbar">
        <li v-for="(option, index) in filteredCols" :key="index">
          <div class="dropdown-item">
            <BootstrapCheck
              :id="`columnCheckbox-${option}`"
              v-model="modelVisibleCols"
              :value="option"
              :label="option"
            />
          </div>
        </li>
      </div>
    </ul>
  </div>
</template>
<script lang="ts" setup>
/**
 * @deprecated Do not use this component anywhere else other than in AdminDataTable.vue
 * This component was made quickly to help Yoeran with his Apim/Admin PoC
 */

const props = defineProps<{
  visibleCols: string[];
  cols: string[];
}>();

const emits = defineEmits<{'update:visibleCols': [item: string[]]}>();

const modelVisibleCols = computed({
  get: () => props.visibleCols,
  set: (value) => emits('update:visibleCols', value),
});

const filteredCols = computed(() => props.cols.slice(1));

const allColumnsVisible = computed(() => modelVisibleCols.value.length === props.cols.length);

const toggleAllColumns = () => {
  if (allColumnsVisible.value) {
    modelVisibleCols.value = [props.cols[0]];
  } else {
    modelVisibleCols.value = [...props.cols];
  }
};
</script>
<style scoped>
.scrollable-menu {
  max-height: 50vh;
  overflow-y: auto;
}
</style>
